var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.9888C20 5.46592 15.5229 0.98877 10 0.98877C4.47715 0.98877 0 5.46592 0 10.9888C0 15.98 3.65684 20.1171 8.4375 20.8673V13.8794H5.89844V10.9888H8.4375V8.78565C8.4375 6.2794 9.93047 4.89502 12.2146 4.89502C13.3084 4.89502 14.4531 5.09033 14.4531 5.09033V7.55127H13.1922C11.95 7.55127 11.5625 8.32217 11.5625 9.11377V10.9888H14.3359L13.8926 13.8794H11.5625V20.8673C16.3432 20.1171 20 15.98 20 10.9888Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ed0f46286c1b318f4fe293366934b6eb.svg";
export { ForwardRef as ReactComponent };